
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.59 0h11.82a.59.59 0 01.417 1.009L9.699 4.136l3.128 3.128a.591.591 0 01-.418 1.009H1.182v4.136a.59.59 0 01-1.182 0V.591A.59.59 0 01.59 0zm.592 1.182V7.09h9.8L8.447 4.554a.59.59 0 010-.835l2.537-2.537H1.181z"}})])
          )
        }
      }
    